import { types } from "../../types/types";

const initialState = {
  regimesBilling: []
}

export const RegimeBillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.regimenesBilling:
      return{
        ...state,
        regimesBilling: [ ...action.payload ]
      }
      
    default:
      return state;
  }
}
